import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, setIdentityMode, pageview, track, EVENTS } from '../services/analytics';
import { flushStaleBuildTelemetry } from '../utils/lazyWithRetry';

// One place that drives all passive analytics (no-op until VITE_POSTHOG_KEY /
// the GA4 measurement id are set). Same shape as the counseling product's,
// minus the auth and feature-flag halves: Fullrun has no signed-in users yet,
// so there is nothing to identify. When accounts arrive, identify() comes
// back here behind the hashed-identity gate, never with a raw email.
//   - init once on mount
//   - a $pageview on every route change (SPA — the browser fires none)
// Renders nothing.
export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    // Hashed identity is the only mode this product has ever had.
    setIdentityMode({ hashed: true, internalPassthrough: false });
    initAnalytics();
  }, []);

  // If the previous page load ended in a stale-build auto-reload, report it
  // now; the reload fires synchronously so the event could not be sent then.
  // TELEMETRY ONLY: this must never restore the retry budget.
  useEffect(() => {
    flushStaleBuildTelemetry((chunk) => track(EVENTS.STALE_BUILD_RELOADED, { chunk }));
  }, []);

  useEffect(() => {
    pageview(location.pathname);
  }, [location.pathname]);

  return null;
}
